export const FETCH_BUILDING_REQUEST = 'digitization/FETCH_BUILDING_REQUEST'
export const FETCH_BUILDING_SUCCESS = 'digitization/FETCH_BUILDING_SUCCESS'
export const FETCH_BUILDING_FAILURE = 'digitization/FETCH_BUILDING_FAILURE'

export const UPDATE_BUILDING_REQUEST = 'digitization/UPDATE_BUILDING_REQUEST'
export const UPDATE_BUILDING_SUCCESS = 'digitization/UPDATE_BUILDING_SUCCESS'
export const UPDATE_BUILDING_FAILURE = 'digitization/UPDATE_BUILDING_FAILURE'

export const CREATE_BUILDING_REQUEST = 'digitization/CREATE_BUILDING_REQUEST'
export const CREATE_BUILDING_SUCCESS = 'digitization/CREATE_BUILDING_SUCCESS'
export const CREATE_BUILDING_FAILURE = 'digitization/CREATE_BUILDING_FAILURE'

export const UPDATE_FIELD = 'digitization/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'digitization/SET_DEFAULT_DATA'
